import { Variables } from '../../configs/appConfigs';

export const getProductIdHeader = () => ({
  'Content-Type': 'application/json',
  'x-source-p': process.env.X_SOURCE_P,
});

export const getDidHeader = () => {
  let headers: Record<string, string> = getProductIdHeader();
  const did = localStorage.getItem(Variables.did);

  if (did) headers.did = did;
  return headers;
};

export const getAtkHeader = () => {
  let headers: Record<string, string> = getProductIdHeader();
  const did = localStorage.getItem(Variables.did);
  const atk = localStorage.getItem(Variables.accessToken);

  if (did) headers.did = did;
  if (atk) headers.atk = atk;

  return headers;
};

export const getRtkHeader = () => {
  let headers: Record<string, string> = getProductIdHeader();
  const did = localStorage.getItem(Variables.did);
  const rtk = localStorage.getItem(Variables.refreshToken);

  if (did) headers.did = did;
  if (rtk) headers.rtk = rtk;

  return headers;
};

export const getAtkRtkHeader = () => {
  let headers: Record<string, string> = getProductIdHeader();
  const did = localStorage.getItem(Variables.did);
  const atk = localStorage.getItem(Variables.accessToken);
  const rtk = localStorage.getItem(Variables.refreshToken);

  if (did) headers.did = did;
  if (atk) headers.atk = atk;
  if (rtk) headers.rtk = rtk;

  return headers;
};
export const getTmtHeader = () => {
  let headers: Record<string, string> = getProductIdHeader();
  const did = localStorage.getItem(Variables.did);
  const tmt = localStorage.getItem(Variables.temptToken);

  if (did) headers.did = did;
  if (tmt) headers.tmt = tmt;

  return headers;
};
